import { OnInit, Component, ViewChild } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { InabilityService } from '../inability.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalEmployeesComponet } from 'app/views/modales/employees/modal-employees.component';
import { IDtoInability } from 'app/shared/models/request/inability/dto-inability.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { PayrollService } from '../../payroll.service';
import { IDtoPeriod } from 'app/shared/models/payroll/dto-period.model';
import { WorkLeaveService } from '../workLeave.service';
import { IDtoMovementRestrictionCalendar } from 'app/shared/models/payroll/dto-movement-restriction-calendar.model';

@Component({
    selector: 'app-inability-request',
    styleUrls: ['inability-request.style.scss'],
    templateUrl: 'inability-request.template.html'
})
export class InabilityRequestComponent implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Notificaciones */
    @ViewChild('addSwal', { static: false }) private addSwal: SwalComponent;
    /**Formularios */
    private formInability: FormGroup;
    private locale: string = 'es';
    /**Catalogos */
    private catalogLineInsurances: Observable<ISelect[]>;
    private catalogTypeRisks: Observable<ISelect[]>;
    private catalogLingeringIssuesKeys: Observable<ISelect[]>;
    private catalogInabilityControlKeys: Observable<ISelect[]>;
    /**Modales */
    private modalRef: BsModalRef;
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    private employee: IDtoEmployee;
    private hasEmployee = false;
    private files: FileList;
    private fileName = '';
    private pickerOptions: IAngularMyDpOptions;
    private currentDate: Date;
    private pickerOptionsDateApplication: IAngularMyDpOptions;
    constructor(private formBuilder: FormBuilder
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private inabilityService: InabilityService
        , private configurationService: ConfigurationService
        , private modalService: BsModalService
        , private identityService: IdentityService
        , private payrollService: PayrollService
        , private workLeaveService: WorkLeaveService) {

    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
            this.spinner.show();
            this.getCatalogs();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.spinner.show();
                this.getCatalogs();
            });
        }
        this.initializeFormInability();
    }
    private getCatalogs(): void {
        this.catalogLineInsurances = this.inabilityService.getCatalogLineInsurances();
        this.workLeaveService.getCurrentDate().subscribe(x => {
            this.currentDate = new Date(x);
            const current = new Date(x);
            current.setDate(current.getDate() - 1);
            this.restrictDate(current);
        });
        this.spinner.hide();
    }
    private getCatalogTypeRisks(id: string): void {
        this.formInability.get('typeRiskId').reset();
        this.formInability.get('lingeringIssuesKeyId').reset();
        this.formInability.get('inabilityControlKeyId').reset();
        this.catalogLingeringIssuesKeys = null;
        this.catalogInabilityControlKeys = null;
        this.catalogTypeRisks = this.inabilityService.getCatalogTypeRisks(id);
    }
    private getCatalogLingeringIssuesKeys(id: string): void {
        this.formInability.get('lingeringIssuesKeyId').reset();
        this.formInability.get('inabilityControlKeyId').reset();
        this.catalogInabilityControlKeys = null;
        this.catalogLingeringIssuesKeys = this.inabilityService.getCatalogLingeringIssuesKeys(id);
    }
    private getCatalogInabilityControlKey(id: string): void {
        this.formInability.get('inabilityControlKeyId').reset();
        this.catalogInabilityControlKeys = this.inabilityService.getCatalogInabilityControlKey(id);
    }
    private initializeFormInability() {
        this.formInability = this.formBuilder.group({
            inabilityKey: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
            numberDays: [null, [Validators.required, Validators.maxLength(3)]],
            startDate: [null, Validators.required],
            dateApplication: [null, Validators.required],
            lineInsuranceId: [null, Validators.required],
            typeRiskId: [null, Validators.required],
            lingeringIssuesKeyId: [null, Validators.required],
            inabilityControlKeyId: [null, Validators.required],
            requiresInability: [null, [Validators.required]],
            comments: [null, [Validators.maxLength(500)]],
            employee: [null, Validators.required],
            inabilityFile: [null, Validators.required]
        });
    }
    private submitForm(): void {
        if (this.formInability.valid) {
            this.addSwal.title = 'Se registrará la incapacacidad para el empleado seleccionado.';
            this.addSwal.show();
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'error');
            this.configGeneral.touchedControls(this.formInability);
        }
    }
    private openModalEmployees() {
        this.modalRef = this.modalService.show(ModalEmployeesComponet
            , Object.assign({ class: 'modal-lg' }, this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.employee = result;
                this.formInability.get('employee').setValue(this.employee.employeeName);
                this.hasEmployee = true;
                this.getRestrictionPayroll();
            } else {
                this.hasEmployee = false;
            }
        });
    }
    private getDate(event: IMyDateModel) {
        return event.singleDate.jsDate;
    }
    private save(): void {
        this.spinner.show();
        let data = Object.assign({}, this.formInability.value as IDtoInability);
        data.employeeId = this.employee.id;
        data.employeeNum = this.employee.employeeNum;
        data.employeeName = this.employee.employeeNames;
        data.employeeLastName = this.employee.employeeLastName;
        data.employeeSecondLastName = this.employee.employeeSecondLastName;
        data.requisitionId = this.employee.requisitionId;
        data.uKey = this.employee.uKey;
        data.startDate = this.configGeneral.getLocalISOTime(this.getDate(this.formInability.value.startDate));
        data.dateApplication = this.configGeneral.getLocalISOTime(this.getDate(this.formInability.value.dateApplication));
        data.fileName = this.fileName;
        data.zoneId = this.employee.zoneId;
        data.townId = this.employee.townId;
        data.codePayroll = this.employee.employeeTypePayrollId;
        data.typePosition = this.employee.typePosition;
        this.inabilityService.addInability(data)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let i = x.data as IDtoInability;
                        this.addModuleLog(i.id);
                        this.upload(i);
                    }
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onFileChange(event) {
        event.value = '';
    }
    private handleFileInput(files: FileList) {
        this.files = files;
        this.fileName = this.files.item(0).name;
    }
    private upload(item: IDtoInability): void {
        if (this.files != undefined) {
            const file = this.files.item(0);
            item.fileName = this.fileName;
            this.inabilityService.uploadFile(item, file).subscribe((res) => {
                this.resetForm();
            });
        }
    }
    private resetForm() {
        this.formInability.reset();
        this.hasEmployee = false;
        this.fileName = '';
    }
    private restrictDate(date: Date) {
        this.pickerOptions = {
            dateFormat: 'dd.mm.yyyy',
            dateRange: false,
            disableDateRanges: [{
                begin: { year: 1000, month: 1, day: 1 },
                end: { year: date.getUTCFullYear(), month: date.getUTCMonth() - 2, day: date.getUTCDate() }
            }]
        }
    }
    private addModuleLog(id: number): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Inabilities';
        dto.module = 'inability';
        dto.action = 'new';
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private getRestrictionPayroll(): void {
        let restriction = {} as IDtoMovementRestrictionCalendar;
        restriction.payrollTypeId = +this.employee.employeeTypePayrollId;
        restriction.currentDate = this.configGeneral.getLocalISOTime(this.currentDate);
        restriction.movementType = 4;
        this.payrollService.restrictionExistCalendar(restriction).subscribe(x => {
            if (x) {
               this.getActivePeriod(); 
            }
        });
    }
    private getActivePeriod(): void {
        let period = {} as IDtoPeriod;
        period.codeNomCompanyPay = this.employee.employeeCompanyId;
        period.codeNomPayroll = this.employee.employeeTypePayrollId;
        period.currentDate = this.configGeneral.getLocalISOTime(this.currentDate);
        this.payrollService.getActivePeriod(period).subscribe(x => {
            if (x.data != null) {
                let resPeriod = x.data as IDtoPeriod;
                this.restrictDateApplication(resPeriod);
            }
        });
        this.spinner.hide();
    }
    private restrictDateApplication(period: IDtoPeriod) {
        let initDate = new Date(period.initDate);
        let endDate = new Date(period.endDate);
        this.pickerOptionsDateApplication = {
            dateFormat: 'dd.mm.yyyy',
            dateRange: false,
            disableDateRanges: [{
                begin: { year:  initDate.getUTCFullYear(), month: initDate.getUTCMonth() + 1, day: initDate.getUTCDate() },
                end: { year: endDate.getUTCFullYear(), month: endDate.getUTCMonth() + 1, day: endDate.getUTCDate() }
            }]
        }
    }
}